<template>
  <div class="custom-node node-start">
    <Handle
      type="source"
      :position="Position.Right"
      :is-valid-connection="isValidConnection"
    />

    <div class="node-content">
      <div class="node-icon">
        <i class="fas fa-play"></i>
      </div>
      <div class="node-label">
        {{ data.label || 'Start' }}
      </div>
    </div>

    <button
      class="node-delete-btn"
      
      @click.stop.prevent="onDelete"
      title="Supprimer le nœud"
    >
      <i class="fas fa-times"></i>
    </button>
  </div>
</template>

<script setup>
import { Handle, Position } from '@vue-flow/core'
import { useVueFlow } from '@vue-flow/core'

const { edges } = useVueFlow()

const props = defineProps({
  id: String,
  data: Object
})

const emit = defineEmits(['delete'])

function onDelete() {
  if (window.confirm('⚠️ Are you sure you want to delete this node? \nThis action cannot be undone.')) {
    emit('delete', { nodeId: props.id, elementId: props.data?.elementId })
  }
}

// Limite à une seule connexion sortante
function isValidConnection(connection) {
  const existingConnections = edges.value.filter(
    edge => edge.source === props.id
  )

  if (existingConnections.length > 0) {
    console.log('🚫 Le nœud de début ne peut avoir qu\'une seule connexion sortante')
    return false
  }

  return true
}
</script>

<style scoped>
.custom-node {
  position: relative;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  min-width: 180px;
  background: white;
  border: 2px solid;
  transition: all 0.3s ease;
}

.custom-node:hover {
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.node-start {
  border-color: #28a745;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
}

.node-content {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.node-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
}

.node-label {
  flex: 1;
  color: white;
  font-weight: 600;
  font-size: 14px;
}

.node-delete-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #dc3545;
  color: white;
  border: 2px solid white;
  display: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.custom-node:hover .node-delete-btn {
  display: flex;
}

.node-delete-btn:hover {
  background: #c82333;
  transform: scale(1.1);
}


.vue-flow__handle {
    width: 16px;
    height: 16px;
    background-color: #40e048 ;
    border: 1px solid #fff;
    border-radius: 100%;

}
</style>
